import type { NotificationPreferences } from "@ishvaram/api-client";
import { ApiError, apiRequest } from "./_fetch";

export type { NotificationPreferences };

export async function subscribeNotifications(data: {
  moon_rashi: string;
  push_token?: string;
  email?: string;
  daily_rashifal?: boolean;
  daily_panchang?: boolean;
  transit_alerts?: boolean;
  device_platform?: string;
}): Promise<{ status: string; data: NotificationPreferences }> {
  return apiRequest("/transits/subscribe", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  });
}

export async function getNotificationPreferences(
  pushToken: string,
): Promise<NotificationPreferences | null> {
  const params = new URLSearchParams({ push_token: pushToken });
  try {
    const body = await apiRequest<{ data: NotificationPreferences }>(
      `/transits/notifications/preferences?${params}`,
    );
    return body.data;
  } catch (e) {
    if (e instanceof ApiError && e.status === 404) return null;
    throw e;
  }
}

export async function updateNotificationPreferences(data: {
  push_token: string;
  daily_rashifal?: boolean;
  daily_panchang?: boolean;
  transit_alerts?: boolean;
  moon_rashi?: string;
}): Promise<NotificationPreferences> {
  const body = await apiRequest<{ data: NotificationPreferences }>(
    "/transits/notifications/preferences",
    {
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    },
  );
  return body.data;
}
